import React from "react";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";

const styles = `
  .access-requested-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #004263 0%, #42b0d5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    font-family: "Maersk Text", Arial, sans-serif;
    color: #004263;
  }

  .access-requested-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 66, 99, 0.18);
    padding: clamp(2rem, 5vw, 3.5rem);
    max-width: 600px;
    width: 90%;
    text-align: center;
  }

  .requested-icon {
    font-size: clamp(5rem, 15vw, 8rem);
    color: #ffa500;
    margin-bottom: 1.5rem;
  }

  .requested-title {
    font-size: clamp(1.8rem, 5vw, 2.6rem);
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .status-pill {
    display: inline-block;
    background: #fff3e0;
    color: #e65100;
    padding: 0.6rem 1.5rem;
    border-radius: 2rem;
    font-weight: 600;
    font-size: 1.1rem;
    margin: 1.5rem 0;
  }

  .requested-message {
    font-size: clamp(1.05rem, 3vw, 1.25rem);
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }
`;

const STYLE_ID = "access-requested-styles-dtr";

if (
  typeof window !== "undefined" &&
  !document.head.querySelector(`style[data-style-id="${STYLE_ID}"]`)
) {
  const style = document.createElement("style");
  style.setAttribute("data-style-id", STYLE_ID);
  style.textContent = styles;
  document.head.appendChild(style);
}

const AccessRequested = () => (
  <div className="access-requested-container">
    <div className="access-requested-card">
      <McIcon icon="time" className="requested-icon" />
      <h1 className="requested-title">Access Request Sent</h1>
      <div className="status-pill">Pending Approval</div>
      <p className="requested-message">
        Your request has been successfully submitted.
        <br />
        The application owner has been notified.
        <br />
        You will receive an email once your access is reviewed.
      </p>
      <p style={{ fontSize: "0.95rem", opacity: 0.8 }}>
        Thank you for your patience.
      </p>
      <p style={{ fontSize: "0.9rem", opacity: 0.75, marginTop: "1.25rem" }}>
        Powered by GDA | IONIS
      </p>
    </div>
  </div>
);

export default AccessRequested;
